module.exports = __webpack_public_path__ + "static/media/bg3.cce729d4.png";